
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import Background from "../../assets/Images/signinBack.jpeg";
import { signinSuccess, signinFailure } from "../../redux/users/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Label, TextInput } from "flowbite-react";
import { useForm } from "react-hook-form";
import { signinSchema } from "../../validation/auth";
import { yupResolver } from "@hookform/resolvers/yup";
import { SIGIN_URL } from "../../resources/resource";
import { toast } from "sonner";
import LoadSpinner from "../../component/Modals/LoadSpinner";
import ForgetPassword from "../../component/Modals/ForgetPassword";
import Header from "../../component/Header";
import FooterComponent from "../../component/Footer";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { useSocket } from "../../hooks/useSocket";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function SigninPages() {
  const forgetURL = `${process.env.REACT_APP_API_URL}forgetPasword/`;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(signinSchema),
  });
  const [loading, setLoading] = useState(false);
  const [forgetPasswordData, setForgetPasswordData] = useState({});
  const [forgetPassowrd, setForgetPassword] = useState(false);
  const [loadingForget, setLoadingForget] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  const makeRequest = useMakeRequest();
  const { connectSocket, disconnectSocket } = useSocket();

  const handleForgetPasswordChange = (e) => {
    e.preventDefault();
    setForgetPasswordData({
      ...forgetPasswordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleForgetPassword = async (e) => {
    e.preventDefault();
    setLoadingForget(true);
    try {
      await axios.post(forgetURL, forgetPasswordData);
      setLoadingForget(false);
      setForgetPassword(!forgetPassowrd);
      toast.success("Password reset request sent");
    } catch (error) {
      setLoadingForget(false);
      toast.error(error.response?.data?.message || "Error sending reset request");
      console.error(error);
    }
  };

  const handleForgetPasswordToggle = () => {
    setForgetPassword(!forgetPassowrd);
  };

  const handleSignin = async (formData) => {
    setLoading(true);
    const onSuccess = (data) => {
      dispatch(signinSuccess(data));
      console.log(data)
   
      toast.success("Sign in successful");
      localStorage.setItem("token", data?.metadata);
      localStorage.setItem("userId", data?._id);
      localStorage.setItem("email", data.email);
  
      localStorage.setItem("_dl_token", data?.metadata);

      connectSocket(data._id);
      navigate("/");
    };

    try {
      await makeRequest(
        SIGIN_URL,
        "POST",
        formData,
        onSuccess,
        (error) => {
          const errorMsg = error.response?.data?.message || error.message;
          toast.error(errorMsg);
          console.error("Signin error:", error);
          dispatch(signinFailure(errorMsg));
        },
        () => {
          setLoading(false);
        },
        { dontNotifyOnSuccess: true, dontNotifyOnFail: true }
      );
    } catch (error) {
      setLoading(false);
      const errorMsg = error.response?.data?.message || "An error occurred. Please try again.";
      dispatch(signinFailure(errorMsg));
      toast.error(errorMsg);
    }
  };

  useEffect(() => {
    return () => {
      disconnectSocket();
    };
  }, [disconnectSocket]);

  return (
    <div className="pt-16 sm:pt-20">
      <Header />
      <div className="w-screen text-sm font-mon h-screen flex items-center justify-center bg-gray-100 p-10">
        <div
          style={{ backgroundImage: `url(${Background})` }}
          className="relative sm:w-1/2 h-full object-cover sm:flex hidden items-center justify-center"
        >
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="relative flex items-center justify-center flex-col mx-auto bg-black/80 w-2/3 h-2/3 text-white font-mon rounded-sm">
            <h1 className="text-3xl mb-3">Welcome to our platform</h1>
            <p className="font-inter w-[300px]">
              Connect with different users and find your perfect match
            </p>
          </div>
        </div>
        <div className="sm:w-1/2 w-full px-14 py-5">
          <form onSubmit={handleSubmit(handleSignin)}>
            <h2 className="text-2xl font-bold mb-6 text-center">Sign In</h2>
            <div className="flex flex-col items-center justify-center py-2 w-full">
              <select
                {...register("userType")}
                className="mx-auto outline-none border-gray-100 border-2 rounded-md px-2 py-1 w-full"
                name="userType"
                id="userType"
              >
                <option disabled value="">
                  Sign in as
                </option>
                <option value="jobSeeker">Job Seeker</option>
                <option value="jobEmployer">Job Employer</option>
                {/* <option value="admin">Admin</option> */}
              </select>
              {errors?.userType && (
                <p className="text-red-500 text-sm">{errors.userType.message}</p>
              )}
            </div>
            <div className="mb-4">
              <Label className="block mb-2 font-medium" htmlFor="email">
                Email 
              </Label>
              <TextInput
                className="w-full py-2 outline-none focus:ring-2 focus:ring-blue-500"
                {...register("email")}
                name="email"
                type="email"
                id="email"
                placeholder="James Johnson"
              />
              {errors?.email && (
                <p className="text-red-500 text-sm">{errors.email.message}</p>
              )}
            </div>
            <div className="mb-4">
              <Label className="block mb-2 font-medium" htmlFor="password">
                Password
              </Label>
              <div className="relative">
                <TextInput
                  className="w-full py-2 outline-none focus:ring-2 focus:ring-blue-500"
                  {...register("password")}
                  name="password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="********"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-blue-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                </button>
              </div>
              {errors?.password && (
                <p className="text-red-500 text-sm">{errors.password.message}</p>
              )}
            </div>
            <Button
              type="submit"
              className="w-full bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600 transition duration-200"
              disabled={loading}
            >
              {loading ? <LoadSpinner /> : "Sign In"}
            </Button>
            <div className="mt-4 text-center">
              <p>
                Don't have an account?{" "}
                <Link
                  className="text-blue-500 hover:underline"
                  to="/signup?currentStep=stepOne"
                >
                  Sign up
                </Link>
              </p>
            </div>
            <Button
              className="text-blue-500 font-semibold text-base underline"
              onClick={handleForgetPasswordToggle}
            >
              Forgot password
            </Button>
          </form>
        </div>
      </div>
      <FooterComponent />
      {forgetPassowrd && (
        <ForgetPassword
          loading={loadingForget}
          onChange={handleForgetPasswordChange}
          forgetPasswordData={forgetPasswordData}
          onSubmit={handleForgetPassword}
          onToggle={handleForgetPasswordToggle}
        />
      )}
    </div>
  );
}

export default SigninPages;






// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Button, Label, TextInput, Spinner } from "flowbite-react";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { signinSchema } from "../../validation/auth";
// import Background from "../../assets/Images/signinBack.jpeg";
// import { useDispatch } from "react-redux";
// import { signinSuccess, signinFailure } from "../../redux/users/userSlice";
// import axios from "axios";
// import { SIGIN_URL } from "../../resources/resource";
// import { toast } from "sonner";
// import ForgetPassword from "../../component/Modals/ForgetPassword";
// import Header from "../../component/Header";
// import FooterComponent from "../../component/Footer";
// import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
// import { FaBriefcase, FaUserGraduate } from "react-icons/fa";
// import { motion } from "framer-motion";

// function SigninPages() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const [selectedRole, setSelectedRole] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [forgetPassowrd, setForgetPassword] = useState(false);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(signinSchema),
//   });

//   const handleRoleSelect = (role) => {
//     setSelectedRole(role);
//   };

//   const onSubmit = async (data) => {
//     if (!selectedRole) {
//       toast.error("Please select your account type");
//       return;
//     }

//     setLoading(true);

//     const payload = {
//       email: data.email,
//       password: data.password,
//       userType: selectedRole,
//     };

//     try {
//       const res = await axios.post(SIGIN_URL, payload);

//       // SUCCESS
//       dispatch(signinSuccess(res.data));
//       toast.success("Welcome back!");

//       localStorage.setItem("token", res.data.token);
//       localStorage.setItem("userId", res.data.data._id);
//       localStorage.setItem("email", res.data.data.email);
//       localStorage.setItem("_dl_token", res.data.token);

//       navigate("/");
//     } catch (error) {
//       // ERROR
//       const errorMsg = error.response?.data?.message || "Invalid email or password";
//       toast.error(errorMsg);
//       dispatch(signinFailure(errorMsg));
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="pt-16 sm:pt-20 min-h-screen bg-gray-50">
//       <Header />
//       <div className="w-full flex flex-col lg:flex-row items-center justify-center min-h-screen p-6">
//         {/* Background */}
//         <div
//           style={{ backgroundImage: `url(${Background})` }}
//           className="hidden lg:block w-full lg:w-1/2 h-screen bg-cover bg-center relative"
//         >
//           <div className="absolute inset-0 bg-black/50"></div>
//           <div className="relative h-full flex items-center justify-center text-white px-16">
//             <div className="max-w-md">
//               <h1 className="text-5xl font-bold mb-6">Welcome Back</h1>
//               <p className="text-xl leading-relaxed">
//                 Connect with opportunities and talent. Your next career move starts here.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Right Side */}
//         <div className="w-full lg:w-1/2 flex items-center justify-center px-6 lg:px-20">
//           <div className="w-full max-w-lg">
//             {!selectedRole ? (
//               <div className="text-center">
//                 <h2 className="text-4xl font-bold text-gray-800 mb-4">Sign In As</h2>
//                 <p className="text-gray-600 mb-10">Choose your account type to continue</p>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-2xl mx-auto">
//                   {/* Job Seeker */}
//                   <motion.div
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.98 }}
//                     onClick={() => handleRoleSelect("jobSeeker")}
//                     className="cursor-pointer bg-white rounded-2xl shadow-xl p-10 border-2 border-transparent hover:border-orange-500 transition-all duration-300"
//                   >
//                     <div className="w-20 h-20 mx-auto mb-6 bg-orange-100 rounded-full flex items-center justify-center">
//                       <FaUserGraduate className="w-10 h-10 text-orange-600" />
//                     </div>
//                     <h3 className="text-2xl font-bold text-gray-800 mb-3">Job Seeker</h3>
//                     <p className="text-gray-600">Looking for your next opportunity</p>
//                   </motion.div>

//                   {/* Employer */}
//                   <motion.div
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.98 }}
//                     onClick={() => handleRoleSelect("jobEmployer")}
//                     className="cursor-pointer bg-white rounded-2xl shadow-xl p-10 border-2 border-transparent hover:border-blue-500 transition-all duration-300"
//                   >
//                     <div className="w-20 h-20 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center">
//                       <FaBriefcase className="w-10 h-10 text-blue-600" />
//                     </div>
//                     <h3 className="text-2xl font-bold text-gray-800 mb-3">Employer</h3>
//                     <p className="text-gray-600">Hiring talent for your company</p>
//                   </motion.div>
//                 </div>
//               </div>
//             ) : (
//               <div className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12">
//                 <button
//                   onClick={() => setSelectedRole("")}
//                   className="mb-6 text-orange-600 hover:text-orange-700 font-medium flex items-center gap-2"
//                 >
//                   ← Back to role selection
//                 </button>

//                 <h2 className="text-3xl font-bold text-center mb-8">
//                   Sign In as {selectedRole === "jobSeeker" ? "Job Seeker" : "Employer"}
//                 </h2>

//                 <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
//                   <div>
//                     <Label>Email Address</Label>
//                     <TextInput
//                       {...register("email")}
//                       type="email"
//                       placeholder="you@example.com"
//                     />
//                     {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
//                   </div>

//                   <div>
//                     <Label>Password</Label>
//                     <div className="relative">
//                       <TextInput
//                         {...register("password")}
//                         type={showPassword ? "text" : "password"}
//                         placeholder="••••••••"
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowPassword(!showPassword)}
//                         className="absolute right-3 top-3 text-gray-500 hover:text-gray-700"
//                       >
//                         {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
//                       </button>
//                     </div>
//                     {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>}
//                   </div>

//                   <Button
//                     type="submit"
//                     className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold text-lg py-6 rounded-xl"
//                     disabled={loading}
//                   >
//                     {loading ? (
//                       <div className="flex items-center gap-3">
//                         <Spinner size="sm" />
//                         <span>Signing In...</span>
//                       </div>
//                     ) : (
//                       "Sign In"
//                     )}
//                   </Button>
//                 </form>

//                 <div className="mt-6 text-center space-y-3">
//                   <button
//                     onClick={() => setForgetPassword(true)}
//                     className="text-orange-600 hover:underline font-medium"
//                   >
//                     Forgot Password?
//                   </button>
//                   <p className="text-gray-600">
//                     Don't have an account?{" "}
//                     <Link to="/signup" className="text-orange-600 font-bold hover:underline">
//                       Sign Up
//                     </Link>
//                   </p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <FooterComponent />
//       {forgetPassowrd && <ForgetPassword onToggle={() => setForgetPassword(false)} />}
//     </div>
//   );
// }

// export default SigninPages;